import axiosInstance from "./axiosInstance";

/**
 * ===========================================
 * Country Payment Gateway APIs
 * ===========================================
 */

export const fetchCountryPaymentGateways = async (params = {}) => {
    const response = await axiosInstance.get(
        "country-payment-gateways/",
        {
            params,
        }
    );
    return response.data;
};

export const createCountryPaymentGateway = async (payload) => {
    const response = await axiosInstance.post(
        "country-payment-gateways/",
        payload
    );
    return response.data;
};

export const updateCountryPaymentGateway = async (id, payload) => {
    const response = await axiosInstance.put(
        `country-payment-gateways/${id}`,
        payload
    );
    return response.data;
};

export const deleteCountryPaymentGateway = async (id) => {
    const response = await axiosInstance.delete(
        `country-payment-gateways/${id}`
    );
    return response.data;
};

export const fetchCountries = async () => {
    const response = await axiosInstance.get("countries/");
    return response.data;
};